import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./yieldPerTimespanActions";
import * as request from "utility/request";
import { YieldPerTimespan } from "types/YieldPerTimespan";
import { AssetClass } from "types/AssetClass";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadYieldPerTimespans = (
  reportControlId: string,
  reportDate: string,
  showIndex: boolean
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<YieldPerTimespan[]>(
        `${apiUrl}/api/yieldpertimespan?reportControlId=${reportControlId}&reportDate=${reportDate}&showIndex=${showIndex}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", error));
    }
  };
};

export const loadYieldPerTimespansByAssetClass = (
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string,
  showIndex: boolean
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString));

    try {
      const res = await request.getResponseJson<YieldPerTimespan[]>(
        `${apiUrl}/api/yieldpertimespan/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}&showIndex=${showIndex}`
      );
      dispatch(loadSuccess(assetClassString, res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(assetClassString, error));
    }
  };
};
